module.exports = __webpack_public_path__ + "img/bpc.792b92b3.png";